module.exports = __webpack_public_path__ + "img/tarj-cr.5830086f.png";